import { Col, Typography, Layout, Space, Button, Tooltip } from "antd";
import { PlusOutlined, ReloadOutlined, AppstoreAddOutlined, FilePdfOutlined } from "@ant-design/icons";
import Header160 from "../../header/header";
const { Title, Text } = Typography;
export default function OrdenesServicioPOHeader({ onCreate, onBulkCreate, onLeerPdf, onRefresh, permissionInsert }) {
  return (
    <div className="container" style={{ paddingBottom: 20 }}>
      <Layout className="container">
        <div className="header-filter-container d-flex align-items-center justify-content-between" style={{ flexWrap: "wrap", gap: 16 }}>
          <Header160 />
          <Col flex="auto" style={{ textAlign: "center", minWidth: 280 }}>
            <Space direction="vertical" size={2} align="center">
              <Title level={4} style={{ margin: 0, color: "#042956", fontWeight: 600 }}>
                Órdenes de Servicio — Ingresos PO
              </Title>
              <Text style={{ color: "#6b7280", fontSize: 13 }}>
                Gestión de PO / productos del módulo Financiero
              </Text>
              <Space wrap size={8} style={{ marginTop: 10, justifyContent: "center" }}>
                {permissionInsert && (
                  <Button type="primary" icon={<PlusOutlined />} onClick={onCreate}>
                    Nueva orden
                  </Button>
                )}
                {permissionInsert && (
                  <Button icon={<AppstoreAddOutlined />} onClick={onBulkCreate}>
                    Múltiple
                  </Button>
                )}
                {permissionInsert && (
                  <Button icon={<FilePdfOutlined />} onClick={onLeerPdf}>
                    Leer PDF
                  </Button>
                )}
                <Tooltip title="Refrescar">
                  <Button icon={<ReloadOutlined />} onClick={onRefresh} />
                </Tooltip>
              </Space>
            </Space>
          </Col>
        </div>
      </Layout>
    </div>
  );
}
